import { forwardRef, useState } from "react";
import { Input, InputProps } from "./Input";
import { ReactComponent as Eye } from "assets/eye.svg";
import clsx from "clsx";

export const InputPassword = forwardRef<HTMLInputElement, InputProps>(
  function InputPassword(props, ref) {
    const [isVisible, setIsVisible] = useState(false);

    return (
      <Input
        {...props}
        type={isVisible ? "text" : "password"}
        className={clsx("w-full", props.className)}
        ref={ref}
        icon={
          <button
            type="button"
            className="absolute top-1/2 right-3 -translate-y-1/2 p-1 hover:opacity-70 transition-opacity"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setIsVisible(!isVisible);
            }}
            aria-label={isVisible ? "Hide password" : "Show password"}
          >
            <Eye className={clsx("text-858494", { "opacity-50": isVisible })} />
          </button>
        }
      />
    );
  }
);
